import { inr } from "@/lib/api";

const Row = ({ label, value, testid, strong }) => (
  <div className={`flex justify-between ${strong ? "text-white" : "text-slate-300"}`}>
    <span className={strong ? "font-heading font-bold text-lg" : "text-sm"}>{label}</span>
    <span className={`font-mono-num ${strong ? "text-2xl font-bold" : "text-sm"}`} data-testid={testid}>{value}</span>
  </div>
);

export const QuoteTotals = ({ t }) => (
  <div className="rounded-2xl bg-slate-900 p-5 space-y-2 grain relative overflow-hidden" data-testid="quote-totals">
    <div className="relative space-y-2">
      <Row label="Taxable Value" value={inr(t.subtotal)} testid="quote-subtotal" />
      {t.inter ? (
        <Row label="IGST" value={inr(t.igst)} testid="quote-igst" />
      ) : (
        <>
          <Row label="CGST" value={inr(t.cgst)} testid="quote-cgst" />
          <Row label="SGST" value={inr(t.sgst)} testid="quote-sgst" />
        </>
      )}
      <Row label="Round Off" value={(t.round_off >= 0 ? "+" : "") + t.round_off.toFixed(2)} />
      <div className="border-t border-slate-700 pt-2"><Row strong label="Grand Total" value={inr(t.grand_total)} testid="quote-grand-total" /></div>
      <div className="text-[11px] text-slate-400">{t.inter ? "Inter-state supply · IGST applied" : "Within Uttar Pradesh · CGST + SGST applied"}</div>
    </div>
  </div>
);
